/*
 * Copyright 2024 Collaterate. All rights reserved.
 */

var configureglobals = new PageGlobals();

var controller = {
    initialize: function () {
        // init page
        var cometRequest = comet.newRequest(chandler, 'INIT', function (cometRequest) {
            if (cometRequest.sessionTracking) {
                growlMessages.showAll(cometRequest);
                if (!cometRequest.hasErrorMessages()) {
                    configureglobals.set('cstockoffering', cometRequest.getObject('WORKINGOFFERING'));
                    controller.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
                    controller.setCQuote(cometRequest.getObject('STOCKQUOTE'));
                    configureglobals.set('cvariantmgr1', cometRequest.getObject('VARIANTDD1'));
                    configureglobals.set('cvariantmgr2', cometRequest.getObject('VARIANTDD2'));
                    configureglobals.set('cvariantmgr3', cometRequest.getObject('VARIANTDD3'));
                    configureglobals.set('ctips', cometRequest.getObject('TIPS'));
                    controller.display();
                    controller.onStockQuoteComplete(configureglobals.cquote != null);
                    if (typeof shippingCalcWidgetController == 'object') {
                        var cshippingcountrylist = cometRequest.getObject(shippingCalcWidgetController.countryListName).list;
                        var cshippingcountry = cometRequest.getObject(shippingCalcWidgetController.countryDD);
                        var cshippingzip = cometRequest.getObject(shippingCalcWidgetController.zipEF);
                        var cshowEstimateShipping = cometRequest.getObject('SHOW_ESTIMATE_SHIPPING');
                        shippingCalcWidgetController.initialize(chandler, cshippingcountrylist, cshippingcountry, cshippingzip, cshowEstimateShipping.value);
                    }
                    controller.generateAdditionalFields();
                    controller.generateAvailableInventory();
                }
            } else {
                var content = '';
                content += '<div id="userMessageError">This site requires browser cookies to be enabled.<br />Please enable cookies and reload this page.</div>';
                dynamic.setDivIdContent('configurator', content);
            }
            configureEvents.onCalcLoaded();
            var configChangeDetails = {
                context: 'init',
                category: confUtil.INIT
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
        cometRequest.addObjectId(stockGlobals.offeringId);
        cometRequest.addObjectId2(configuratorGlobals.orderItemId);
        cometRequest.send();
    },
    onLogin: function () {
        controller.getQuote(true, function () {
            var configChangeDetails = {
                context: 'onLogin',
                category: confUtil.LOGIN
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
    },
    getOfferingName: function () {
        var cstockoffering = configureglobals.cstockoffering;
        if (cstockoffering == null) {
            return '';
        }
        return cstockoffering.name;
    },
    setCQuoteData: function (object) {
        configureglobals.set('cquotedata', object);
        this.validation = new JobQuoteValidation(object.validation);
        dynamic.setDivIdContent('validationMessagesDiv', this.validation.generateGlobalMessages());
    },
    setCQuote: function (cquote) {
        configureglobals.set('cquote', cquote);

        if (configureglobals.cquote) {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, configureglobals.cquote);
        } else {
            window.tbg.eventHub.trigger(window.tbg.eventHub.events.QUOTE_SET, {});
        }

        if (cquote == null) {
            dynamic.setDivIdContent('productQuotePrices', '--');
        } else {
            var content = '';
            var table = new JDTable({
                cssClass: 'quote'
            });
            table.addRow([
                {
                    text: (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0 ? 'Original ' : 'Your ') + 'Price',
                    tag: 'th',
                    scope: 'row'
                },
                {
                    text: '<span class="lineItemPrice">$' + cquote.jobTotalPriceDisplay + '</span>'
                }
            ], {
                cssClass: 'productPrice'
            });
            if (cquote.offeringDiscountPercent != 0 || cquote.userDiscountPercent != 0) {
                if (cquote.offeringDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + cquote.offeringDiscountPercent + '% Savings',
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobOfferingDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount'
                    });
                }
                if (cquote.userDiscountPercent != 0) {
                    table.addRow([
                        {
                            text: '' + strWeb(cquote.userDiscountName),
                            tag: 'th',
                            scope: 'row'
                        },
                        {
                            text: '<span class="lineItemPrice">-$' + cquote.jobUserDiscountPriceDisplay + '</span>'
                        }
                    ], {
                        cssClass: 'productDiscount userDiscount'
                    });
                }
                table.addRow([
                    {
                        text: 'Your Price',
                        tag: 'th',
                        scope: 'row'
                    },
                    {
                        text: '<span class="lineItemPrice">$' + cquote.totalPriceDisplay + '</span>'
                    }
                ], {
                    cssClass: 'productPrice discounted'
                });
            }
            content += table.generate();
            dynamic.setDivIdContent('productQuotePrices', content);
        }
    },
    display: function () {
        var cstockoffering = configureglobals.cstockoffering;
        var variantTitleCount = 0;
        if (cstockoffering.systemLevelOffering == true) {
            var csystemoffering = cstockoffering.systemOffering;
            variantTitleCount = csystemoffering.getStockAttributeTitleCount();
        } else {
            variantTitleCount = cstockoffering.getStockAttributeTitleCount();
        }
        if (variantTitleCount == 0) {
            controller.generateSingleInventory();
        }
        if (variantTitleCount > 0) {
            controller.generateVariantChoice1();
        }
        if (variantTitleCount > 1) {
            controller.generateVariantChoice2();
        }
        if (variantTitleCount > 2) {
            controller.generateVariantChoice3();
        }
        controller.redisplayAfterVariantSwitch();
    },
    redisplayAfterVariantSwitch: function () {
        // (re)display all fields common to all variants
        controller.generateQuantityDiv();
        controller.generateUnitStockPriceOverrideAmountDiv();
        controller.generateUnitWeightLbsOverrideAmountDiv();
    },
    efVals: {},
    ef: null,
    efFocus: function (fieldName, containerDivId, buttonDivId) {
        this.ef = fieldName;
        this.efVals[fieldName] = getFormItemValue(fieldName, document);

        // var cssClass = dynamic.getClass(containerDivId);
        dynamic.addClass(containerDivId, 'focus');
        dynamic.setDivIdContent(buttonDivId, forms.button('Update', {
            cssClass: 'secondary config'
        }));
    },
    efBlur: function (fieldName, containerDivId, buttonDivId) {
        var previousValue = this.efVals[fieldName];
        dynamic.removeClass(containerDivId, 'focus');
        dynamic.setDivIdContent(buttonDivId, '');
        var newValue = getFormItemValue(fieldName, document);
        if (previousValue != newValue || fieldName == 'QUANTITYEF') {
            var configChangeDetails = {
                context: 'efBlur',
                category: confUtil.FIELD_CHANGE,
                fieldName: fieldName,
                fieldType: 'EF',
                previousValue: previousValue,
                newValue: newValue
            };
            configureEvents.onCalcChanged(configChangeDetails);
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            }, function () { // on failure reset to the previous value.
                setFieldValue(fieldName, previousValue, document);
            });
            this.ef = null;
        }
    },
    setOptionDiv: function (divId, content) {
        if (content == '') {
            dynamic.setClass(divId, 'optionWrapperEmpty');
        } else {
            dynamic.setClass(divId, 'optionWrapperOn');
        }
        dynamic.setDivIdContent(divId, content);
    },
    generateSingleInventory: function () {
        var cstockoffering = configureglobals.cstockoffering;
        var variants = null;
        if (cstockoffering.systemLevelOffering == true) {
            var csystemoffering = cstockoffering.systemOffering;
            variants = csystemoffering.variants;
        } else {
            variants = cstockoffering.variants;
        }
        variant = variants[0];
        var content = '';

        // content += '<label class="config">SKU</label>';
        // content += variant.skuSuffix;
        controller.setOptionDiv('variantDiv1', content);
    },
    generateVariantChoice1: function () {
        var fieldName = 'VARIANTDD1';
        var content = '';
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
        var cstockoffering = configureglobals.cstockoffering;
        var workingOffering = null;
        if (cstockoffering.systemLevelOffering == true) {
            workingOffering = cstockoffering.systemOffering;
        } else {
            workingOffering = cstockoffering;
        }
        var mgr = configureglobals.cvariantmgr1;
        var cvariantchoices = mgr.filteredElements;
        var selectedchoice = mgr.choice;

        var help = '';

        // if (configureglobals.clpjc.showPrintSubstrateTip) {
        //    help = tags.a('Help','javascript:help.tip(configureglobals.clpjc,\'printSubstrateTip\',\''+TBGBOLargeFormatTip.PRINTSUBSTRATES+'\')', {id:'printSubstrateTip', cssClass:'quoteHelp', tabindex:'-1', title:'More Information'});
        // }
        content += '<label class="config">' + help + workingOffering.stockAttributeTitle1 + '</label>';
        content += forms.dd(fieldName, cvariantchoices, selectedchoice, {
            showNullOption: false,
            cssClass: 'configSelect' + (error ? ' error' : ''),
            onchange: 'controller.setVariantChoice1()'
        });
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('variantDiv1', content);
    },
    setVariantChoice1: function () {
        var configChangeDetails = {
            context: 'setVariantChoice1',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'VARIANTDD1',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('VARIANTDD1', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETVARIANT1', function (cometRequest) {
            controller.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            controller.setCQuote(cometRequest.getObject('STOCKQUOTE'));
            configureglobals.set('cvariantmgr1', cometRequest.getObject('VARIANTDD1'));
            growlMessages.showAll(cometRequest);
            controller.generateVariantChoice1();
            controller.redisplayAfterVariantSwitch();
            controller.onStockQuoteComplete(configureglobals.cquote != null);

            // controller.getQuote();
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('VARIANTDD1', false, document);
        cometRequest.addFormField('QUANTITYEF', false, document);
        cometRequest.send();
    },
    generateVariantChoice2: function () {
        var fieldName = 'VARIANTDD2';
        var content = '';
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
        var cstockoffering = configureglobals.cstockoffering;
        var workingOffering = null;
        if (cstockoffering.systemLevelOffering == true) {
            workingOffering = cstockoffering.systemOffering;
        } else {
            workingOffering = cstockoffering;
        }
        var mgr = configureglobals.cvariantmgr2;
        var cvariantchoices = mgr.filteredElements;
        var selectedchoice = mgr.choice;

        var help = '';

        // if (configureglobals.clpjc.showPrintSubstrateTip) {
        //    help = tags.a('Help','javascript:help.tip(configureglobals.clpjc,\'printSubstrateTip\',\''+TBGBOLargeFormatTip.PRINTSUBSTRATES+'\')', {id:'printSubstrateTip', cssClass:'quoteHelp', tabindex:'-1', title:'More Information'});
        // }
        content += '<label class="config">' + help + workingOffering.stockAttributeTitle2 + '</label>';
        content += forms.dd(fieldName, cvariantchoices, selectedchoice, {
            showNullOption: false,
            cssClass: 'configSelect' + (error ? ' error' : ''),
            onchange: 'controller.setVariantChoice2()'
        });
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('variantDiv2', content);
    },
    setVariantChoice2: function () {
        var configChangeDetails = {
            context: 'setVariantChoice2',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'VARIANTDD2',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('VARIANTDD2', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETVARIANT2', function (cometRequest) {
            controller.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            controller.setCQuote(cometRequest.getObject('STOCKQUOTE'));
            configureglobals.set('cvariantmgr2', cometRequest.getObject('VARIANTDD2'));
            growlMessages.showAll(cometRequest);
            controller.generateVariantChoice2();
            controller.redisplayAfterVariantSwitch();
            controller.onStockQuoteComplete(configureglobals.cquote != null);

            // controller.getQuote();
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('VARIANTDD2', false, document);
        cometRequest.addFormField('QUANTITYEF', false, document);
        cometRequest.send();
    },
    generateVariantChoice3: function () {
        var fieldName = 'VARIANTDD3';
        var content = '';
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
        var cstockoffering = configureglobals.cstockoffering;
        var workingOffering = null;
        if (cstockoffering.systemLevelOffering == true) {
            workingOffering = cstockoffering.systemOffering;
        } else {
            workingOffering = cstockoffering;
        }
        var mgr = configureglobals.cvariantmgr3;
        var cvariantchoices = mgr.filteredElements;
        var selectedchoice = mgr.choice;
        var help = '';

        // if (configureglobals.clpjc.showPrintSubstrateTip) {
        //    help = tags.a('Help','javascript:help.tip(configureglobals.clpjc,\'printSubstrateTip\',\''+TBGBOLargeFormatTip.PRINTSUBSTRATES+'\')', {id:'printSubstrateTip', cssClass:'quoteHelp', tabindex:'-1', title:'More Information'});
        // }
        content += '<label class="config">' + help + workingOffering.stockAttributeTitle3 + '</label>';
        content += forms.dd(fieldName, cvariantchoices, selectedchoice, {
            showNullOption: false,
            cssClass: 'configSelect' + (error ? ' error' : ''),
            onchange: 'controller.setVariantChoice3()'
        });
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('variantDiv3', content);
    },
    setVariantChoice3: function () {
        var configChangeDetails = {
            context: 'setVariantChoice3',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'VARIANTDD3',
            fieldType: 'DD',
            previousValue: null,
            newValue: getDropDownSelectedValue('VARIANTDD3', document)
        };
        configureEvents.onCalcChanged(configChangeDetails);
        var cometRequest = comet.newRequest(chandler, 'SETVARIANT3', function (cometRequest) {
            controller.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            controller.setCQuote(cometRequest.getObject('STOCKQUOTE'));
            configureglobals.set('cvariantmgr3', cometRequest.getObject('VARIANTDD3'));
            growlMessages.showAll(cometRequest);
            controller.generateVariantChoice3();
            controller.redisplayAfterVariantSwitch();
            controller.onStockQuoteComplete(configureglobals.cquote != null);

            // controller.getQuote();
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
        cometRequest.statusDivId = 'jobQuote';
        cometRequest.addDropDown('VARIANTDD3', false, document);
        cometRequest.addFormField('QUANTITYEF', false, document);
        cometRequest.send();
    },
    generateQuantityDiv: function () {
        var fieldName = 'QUANTITYEF';
        var content = '';
        var cquotedata = configureglobals.cquotedata;
        var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
        var help = '';

        // if (configureglobals.cpjc.showQtyTip) {
        //    help = tags.a('Help','javascript:help.tip(configureglobals.cpjc,\'qtyTip\',\''+TBGBOTip.QUANTITY+'\')', {id:'qtyTip', cssClass:'quoteHelp', tabindex:'-1', title:'More Information'});
        // }
        var soldascontent = '';
        var cstockoffering = configureglobals.cstockoffering;
        if (cstockoffering.systemLevelOffering == true) {
            cstockoffering = cstockoffering.systemOffering;
        }
        if (cstockoffering.stockUnitOfMeasure != null) {
            soldascontent += ' (' + cstockoffering.stockUnitOfMeasure.namePlural + ')';
        }
        content += help + '<label class="config">' + configureglobals.cquotedata.quantityLabel + soldascontent + '</label>';
        content += forms.ef(fieldName, cquotedata.quantity, {
            size: 5,
            cssClass: 'configField' + (error ? ' error' : ''),
            onfocus: 'controller.efFocus(\'' + fieldName + '\',\'quantityDiv\', \'quantityFocus\')',
            onblur: 'controller.efBlur(\'' + fieldName + '\',\'quantityDiv\', \'quantityFocus\')'
        });
        content += '<span id="quantityFocus" class="changeFocusButton"><!-- dynamic --></span>';
        if (error) {
            content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
        }
        controller.setOptionDiv('quantityDiv', content);
    },
    generateUnitStockPriceOverrideAmountDiv: function () {
        if (dynamic.divIdExists('unitStockPriceOverrideAmountDiv') && configuratorGlobals.isQuoteModePrivileged) {
            var fieldName = 'UNIT_STOCK_PRICE_OVERRIDE_AMOUNT_EF';
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            content += help + '<label class="config">Unit Price</label>';
            content += forms.ef(fieldName, cquotedata.unitStockPriceOverrideAmount, {
                size: 5,
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'controller.efFocus(\'' + fieldName + '\',\'unitStockPriceOverrideAmountDiv\', \'unitStockPriceOverrideAmountFocus\')',
                onblur: 'controller.efBlur(\'' + fieldName + '\',\'unitStockPriceOverrideAmountDiv\', \'unitStockPriceOverrideAmountFocus\')'
            });
            content += '<span id="unitStockPriceOverrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            controller.setOptionDiv('unitStockPriceOverrideAmountDiv', content);
        }
    },
    generateUnitWeightLbsOverrideAmountDiv: function () {
        if (dynamic.divIdExists('unitWeightLbsOverrideAmountDiv') && configuratorGlobals.isQuoteModePrivileged) {
            var fieldName = 'UNIT_WEIGHT_LBS_OVERRIDE_AMOUNT_EF';
            var content = '';
            var cquotedata = configureglobals.cquotedata;
            var error = controller.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var help = '';
            content += help + '<label class="config">Unit Weight (lbs)</label>';
            content += forms.ef(fieldName, cquotedata.unitWeightLbsOverrideAmount, {
                size: 5,
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'controller.efFocus(\'' + fieldName + '\',\'unitWeightLbsOverrideAmountDiv\', \'unitWeightLbsOverrideAmountFocus\')',
                onblur: 'controller.efBlur(\'' + fieldName + '\',\'unitWeightLbsOverrideAmountDiv\', \'unitWeightLbsOverrideAmountFocus\')'
            });
            content += '<span id="unitWeightLbsOverrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += controller.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            controller.setOptionDiv('unitWeightLbsOverrideAmountDiv', content);
        }
    },
    getQuote: function (isLogin, onQuoteUpdatedFunction, onQuoteUpdateFailedFunction) {
        var cometRequest = comet.newRequest(chandler, 'GET_FIELD_CHANGE_QUOTE_ACTION', function (cometRequest) {
            controller.setCQuoteData(cometRequest.getObject('QUOTEINPUTDATA'));
            controller.setCQuote(cometRequest.getObject('STOCKQUOTE'));
            growlMessages.showAll(cometRequest);
            controller.display();
            if (isLogin && typeof shippingCalcWidgetController == 'object') {
                var cshippingcountry = cometRequest.getObject(shippingCalcWidgetController.countryDD);
                var cshippingzip = cometRequest.getObject(shippingCalcWidgetController.zipEF);
                shippingCalcWidgetController.onLogin(cshippingcountry, cshippingzip);
            }
            controller.onStockQuoteComplete(configureglobals.cquote != null);
            if (controller.ef != null) {
                focusOn(controller.ef, document);
                selectAll(controller.ef, document);
            }
            if (typeof onQuoteUpdatedFunction == 'function') {
                onQuoteUpdatedFunction();
            }
        }, null, onQuoteUpdateFailedFunction);
        cometRequest.statusDivId = 'jobQuote';
        if (isLogin) {
            cometRequest.addParameter('ONLOGIN', 'true');
        }
        cometRequest.addFormField('QUANTITYEF', false, document);
        cometRequest.addFormField('UNIT_STOCK_PRICE_OVERRIDE_AMOUNT_EF', false, document);
        cometRequest.addFormField('UNIT_WEIGHT_LBS_OVERRIDE_AMOUNT_EF', false, document);
        dynamic.setDivIdContent('jobQuote', '--');
        cometRequest.send();
    },
    parentController: null,
    onStockQuoteComplete: function (success) {
        if (this.parentController != null) {
            this.parentController.stockQuoteComplete(success);
        }
        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.onQuoteChange();
        }
    },
    generateAdditionalFields: function () {
        var cstockoffering = configureglobals.cstockoffering;
        var cofferingmetadata = cstockoffering.metadata;
        var cquote = configureglobals.cquote;
        var cquoteadditionalfields = cquote == null ? null : cquote.additionalFields;
        var content = '';
        for (var i = 0, ni = cofferingmetadata ? cofferingmetadata.length : 0; i < ni; i++) {
            var acofferingmetadata = cofferingmetadata[i];
            var cquoteadditionalfieldsvalue = '';
            if (cquoteadditionalfields != null) {
                for (var propName in cquoteadditionalfields) {
                    var field = cquoteadditionalfields[propName];
                    if (field && field.QUESTION == acofferingmetadata.name) {
                        cquoteadditionalfieldsvalue = field.ANSWER;
                        break;
                    }
                }
            }
            var datatype = acofferingmetadata.dataType.id;
            content += '<div id="ai' + acofferingmetadata.id + '" class="optionWrapperOn' + (acofferingmetadata.required ? ' required' : '') + '">';
            var fieldName = 'ADDITIONALFIELD' + i;
            if (datatype == 'EF') {
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.ef(fieldName, strWeb(cquoteadditionalfieldsvalue), {
                    cssClass: 'additionalText' + (acofferingmetadata.required ? ' required' : ''),
                    onblur: 'controller.updateMetadata()'
                });
            } else if (datatype == 'TA') {
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.ta(fieldName, strWeb(cquoteadditionalfieldsvalue), {
                    rows: 4,
                    cssClass: 'additionalTA' + (acofferingmetadata.required ? ' required' : ''),
                    onblur: 'controller.updateMetadata()'
                });
            } else if (datatype == 'DD') {
                var ddValues = acofferingmetadata.preDefinedTextValues;
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.dd(fieldName, ddValues.list, {
                    id: cquoteadditionalfieldsvalue
                }, {
                    cssClass: 'configSelect additional' + (acofferingmetadata.required ? ' required' : ''),
                    onblur: 'controller.updateMetadata()'
                });
            } else if (datatype == 'CB') {
                content += forms.cb(fieldName, acofferingmetadata.name, cquoteadditionalfieldsvalue, {
                    onchange: 'controller.updateMetadata()'
                });
            } else if (datatype == 'DP') {
                content += tags.label(acofferingmetadata.name, {
                    cssClass: 'config'
                }) + forms.ef(fieldName, strWeb(cquoteadditionalfieldsvalue), {
                    cssClass: 'additionalText datepicker' + (acofferingmetadata.required ? ' required' : ''),
                    autocomplete: 'nope',
                    onchange: 'controller.updateMetadata()'
                });
            }

            content += '</div>';
        }
        dynamic.setDivIdContent('additionalProductFields', content);
        $('.datepicker').datepicker({
            showOn: 'focus'
        });
    },
    addToCart: function () {
        if (this.isProcessing) {
            return;
        }
        if (this.metadataIsValid()) {
            this.isProcessing = true;
            var cometRequest = this.createMetadataRequest('CONFIGURE_CONTINUE_ACTION');
            cometRequest.failureResultHandlerFunction = function () {
                growlMessages.showAll('Request Failed');
                this.isProcessing = false;
            }.bind(this);
            cometRequest.send();
        }
    },
    metadataIsValid: function () {
        var validator = new Validator();
        var quoteValidation = controller.validation;
        quoteValidation.setValidationErrorReasons(validator);
        validator.addItem(this.createMetadataValidateItem());
        return validator.isValid();
    },
    updateMetadata: function () {
        var cometRequest = this.createMetadataRequest('UPDATE_METADATA_ACTION');
        cometRequest.send();
    },
    createMetadataValidateItem: function () {
        return new CustomValidateItem(null, function () {
            var cstockoffering = configureglobals.cstockoffering;
            var cofferingmetadata = cstockoffering.metadata;
            this.reason = '';
            if (cofferingmetadata != null) {
                for (var i = 0; i < cofferingmetadata.length; i++) {
                    var acofferingmetadata = cofferingmetadata[i];
                    if (acofferingmetadata.required) {
                        var datatype = acofferingmetadata.dataType.id;
                        if (datatype == 'EF' || datatype == 'DD' || datatype == 'TA' || datatype == 'DP') {
                            if (!itemHasValue(getFormItem('ADDITIONALFIELD' + i, document))) {
                                this.reason += '"' + acofferingmetadata.name + '"' + ' is required\n';
                            }
                        } else {
                            if (!isChecked('ADDITIONALFIELD' + i, document)) {
                                this.reason += '"' + acofferingmetadata.name + '"' + ' must be checked\n';
                            }
                        }
                    }
                }
            }
            return this.reason == '';
        });
    },
    createMetadataRequest: function (action) {
        this.reason = '';
        var cometRequest = comet.newRequest(chandler, action, function (cometRequest) {
            if (cometRequest.hasAnyErrorMessages()) {
                growlMessages.showAll(cometRequest);
            } else if (action == 'CONFIGURE_CONTINUE_ACTION') {
                controller.gotoNextStep();
            }
        });

        var cofferingmetadata = configureglobals.cstockoffering.metadata;
        for (var i = 0, ni = cofferingmetadata ? cofferingmetadata.length : 0; i < ni; i++) {
            var acofferingmetadata = cofferingmetadata[i];
            var datatype = acofferingmetadata.dataType.id;
            if (datatype == 'EF' || datatype == 'TA' || datatype == 'DP') {
                cometRequest.addFormField('ADDITIONALFIELD' + i, false, document);
            } else if (datatype == 'CB') {
                cometRequest.addCheckBox('ADDITIONALFIELD' + i, false, document);
            } else if (datatype == 'DD') {
                cometRequest.addDropDown('ADDITIONALFIELD' + i, false, document);
            }
        }

        return cometRequest;
    },
    gotoNextStep: function () {
        if (hasValue(configuratorGlobals.nextStepUrl)) {
            gotoURL(configuratorGlobals.nextStepUrl);
        }
    },
    generateAvailableInventory: function () {
        var offering = configureglobals.cstockoffering.systemOffering ? configureglobals.cstockoffering.systemOffering : configureglobals.cstockoffering;
        var variants = offering.variants;
        var numberOfAttributes = 0;
        var attr1, attr2, attr3;
        if (offering.stockAttributeTitle1 != '') {
            numberOfAttributes++;
            attr1 = offering.stockAttributeTitle1;
        }
        if (offering.stockAttributeTitle2 != '') {
            numberOfAttributes++;
            attr2 = offering.stockAttributeTitle2;
        }
        if (offering.stockAttributeTitle3 != '') {
            numberOfAttributes++;
            attr3 = offering.stockAttributeTitle3;
        }
        content = '';
        if (variants.length > 1) {
            content += '<table id="available-inventory"><tr>';
            for (var i = 0; i < numberOfAttributes; i++) {
                var count = i + 1;
                content += '<th style="text-align: left">' + eval('attr' + count) + '</th>';
            }
            content += '<th style="text-align: left">Inventory</th>';
            content += '</tr>';

            for (var i = 0; i < variants.length; i++) {
                if (variants[i].enabled) {
                    content += '<tr>';
                    for (var a = 0; a < numberOfAttributes; a++) {
                        var count = a + 1;
                        var choice = eval('variants[' + i + '].attribute' + count + 'Choice');
                        content += '<td>' + choice + '</td>';
                    }
                    content += '<td>' + Math.max(variants[i].availableInventory, 0) + '</td>';
                    content += '</tr>';
                }
            }
            content += '</table>';
        } else {
            content += 'Available Inventory: <span class="inventory-count">' + Math.max(variants[0].availableInventory, 0) + '</span>';
        }
        dynamic.setDivIdContent('availableInventoryQuantity', content);
    }
};

$(function () {
    controller.initialize();
});
